import axios from '@/core/services/api.service'

export default {
  changeLang({ commit }, lang) {
    window.localStorage.setItem('tumar_lang', lang)
    commit('SET_LANGUAGE', lang)
  },
  fetchLocales({ commit }) {
    const api = '/frontend/locale'
    return axios.get(api).then((res) => {
      commit('SET_LOCALES', res.data)
    })
  },
}
